<mat-menu #perspectivas="matMenu">
  @if (tablero === 'tendencia' || tablero === 'matriz' ) {
    <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="regmenu" >
      <span>{{'persp.pers8'+tipo | translate}}</span>
    </button>
    <button class="mat-menu-item" [disabled]="idInstitucion == 1002" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="metomenu" >
      <span>{{'persp.pers2'+tipo | translate}}</span>
    </button>
  }
  @if ( tablero === 'matriz' ) {
    <button  class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="sectormenu" >
      <span>{{'persp.pers4' | translate}}</span>
    </button>  
    @if (idInstitucion === 2008) {
      <button  class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="asesormenu" >
        <span>{{'persp.pers14' | translate}}</span>
      </button>
    }      
  }
  @if(tablero === 'cosechas' && idInstitucion === 2) {
    <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="regmenu" >
      <span>{{'persp.pers8'+tipo | translate}}</span>
    </button>
    <button class="mat-menu-item" [disabled]="idInstitucion == 1002" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="metomenu" >
      <span>{{'persp.pers2'+tipo | translate}}</span>
    </button>
    <button  class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="sectormenu" >
      <span>{{'persp.pers4' | translate}}</span>
    </button>
  }
  @if(tablero === 'cosechas' && idInstitucion !== 2){
    <button mat-menu-item [matMenuTriggerFor]="regmenu">
      <span>{{'persp.pers1' | translate}}</span>
    </button>
    <button [disabled]="idInstitucion == 1002" mat-menu-item [matMenuTriggerFor]="metomenu">
      <span>{{'persp.pers2'+tipo | translate}}</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="sectormenu">
      <span>{{'persp.pers4' | translate}}</span>
    </button>
    @if(idInstitucion === 2008){
      <button  class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="asesormenu" >
        <span>{{'persp.pers14' | translate}}</span>
      </button> 
    }
  }  
  @if (tablero === 'concentracion') {
    <button (click)="filtroSelect('Sucursal', 'Oficinas')" mat-menu-item>{{'persp.pers80'|translate}}</button>
    <button (click)="filtroSelect('Sector', 'Sector')" mat-menu-item>{{'persp.pers4'|translate}}</button>
    @if (idInstitucion === 2) {
      <button (click)="filtroSelect('Zona', 'Regiones')" mat-menu-item>{{'persp.pers9'|translate}}</button>
    }    
    <button (click)="filtroSelect('Genero', 'Género')" mat-menu-item>{{'persp.pers5'|translate}}</button>
    <button (click)="filtroSelect('EstatusCredito', 'Estatus crédito')" mat-menu-item>{{'persp.pers6'|translate}}</button>
    <button (click)="filtroSelect('Garantia', 'Garantía')" mat-menu-item>{{'persp.pers7'|translate}}</button>
  }
  @if (tablero === 'concentracion2') {
    <button [disabled]="idInstitucion === 1002" (click)="filtroSelect('Producto','persp.pers10')" mat-menu-item>{{'persp.pers10'|translate}}</button>
    <button (click)="filtroSelect('CategoriaCredito','persp.pers11')" mat-menu-item>{{'persp.pers11'|translate}}</button>
    <button (click)="filtroSelect('TipoCredito','persp.pers12')" mat-menu-item>{{'persp.pers12'|translate}}</button> 
  }
</mat-menu>
          
<mat-menu class="w3-medium" #regmenu="matMenu">
  @switch(tipo){
    @case (0) {
      @for (suc of dataSucursal; track $index) {
        @if (suc.Nombre_Sucursal !== 'Sin Datos') {
          <button class="mat-menu-item"
            (click)="filtroSelect(suc, 'sucursal'); $event.stopPropagation()" 
            mat-menu-item >
            {{suc.Nombre_Sucursal | capitalize:'words'}}
          </button>
        }
      }
    }
    @case (1) { 
      @for (reg of dataZona; track $index) {
        @if (reg.Nombre_Zona !== 'Sin Datos') {
          <button class="mat-menu-item" (click)="filtroSelect(reg, 'zona'); $event.stopPropagation()" 
            mat-menu-item [matMenuTriggerFor]="sucmenu">
            {{reg.Nombre_Zona | capitalize:'words'}}
          </button>
          <mat-menu #sucmenu="matMenu" [overlapTrigger]="false">
            @for (suc of reg.sucursales; track $index) {
              <button mat-menu-item (click)="filtroSelect(suc, 'sucursal'); $event.stopPropagation()"> <!--poner cambio periodo-->
                <span style="margin-left: 5px; float: left;">{{suc.Nombre_Sucursal | capitalize:'words'}}</span> 
              </button>
            }                      
          </mat-menu>
        }
      }
    }
  }
</mat-menu>
<mat-menu class="w3-medium" #metomenu="matMenu">
  @switch (tipo) {
    @case (0) {
      @for (prod of dataProducto; track $index) {
        @if (prod.nombre !== 'Sin Datos') {
          <!-- filtrarProducto(prod); -->
          <button class="mat-menu-item" (click)="filtroSelect(prod, 'producto'); $event.stopPropagation()" 
            mat-menu-item>
            {{prod.Nombre_Producto | capitalize: 'words'}}
          </button>
        }
      }
    }
    @case (1) {
      @for (met of dataMetodologia; track $index) {
        @if (met.nombre !== 'Sin Datos') {
          <button class="mat-menu-item" (click)="$event.stopPropagation()" 
            mat-menu-item [matMenuTriggerFor]="prodmenu">
            {{met.nombre}}
          </button>
          <mat-menu #prodmenu="matMenu" [overlapTrigger]="false">
            @for (prod of met.prod; track $index) {
              <!-- filtrarProducto(prod); -->
              <button mat-menu-item (click)="filtroSelect(prod, 'producto'); $event.stopPropagation()">
                <span style="margin-left: 5px; float: left;">{{prod.Nombre_Producto}}</span> 
              </button>
            }                      
          </mat-menu>
        }
      }
    }
  }            
</mat-menu>
<mat-menu class="w3-medium" #sectormenu="matMenu">
  @for (sec of sectors; track $index) {
    <button class="mat-menu-item" mat-menu-item (click)="filtroSelect(sec, 'sector')">
      <span>{{sec.Nombre_Sector | capitalize:'words'}}</span>
    </button>
  }              
</mat-menu>
<mat-menu #asesormenu="matMenu" hasBackdrop="true" [overlapTrigger]="false" class="menu-busqueda">
  <!-- Campo de búsqueda -->
  <div class="menu-search">
    <input
      matInput
      placeholder="Buscar asesor..."
      (keydown)="$event.stopImmediatePropagation()"
      (click)="$event.stopPropagation()"
      (keyup)="filtrarAsesores($event)"
    />
  </div>

  <!-- Opciones filtradas -->
  @for (asesor of dataAsesorFiltrados; track $index) {
    <button class="mat-menu-item"
      mat-menu-item
      (click)="filtroSelect(asesor, 'asesor')">
      
      <span>
        {{ asesor.Nombre_Asesor === '' 
            ? 'Sin nombre' 
            : (asesor.Nombre_Asesor | capitalize:'words') }}
      </span>

    </button>
  }   
</mat-menu>